import { render, staticRenderFns } from "./CheckupLayout.vue?vue&type=template&id=526a18c4&scoped=true&"
import script from "./CheckupLayout.vue?vue&type=script&lang=js&"
export * from "./CheckupLayout.vue?vue&type=script&lang=js&"
import style0 from "./CheckupLayout.vue?vue&type=style&index=0&id=526a18c4&lang=scss&scoped=true&"
import style1 from "./CheckupLayout.vue?vue&type=style&index=1&id=526a18c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a18c4",
  null
  
)

export default component.exports